import React from 'react'
import styled from 'styled-components'
import { translate } from '~/core/translate'

import appConfig from '../app-config'

const CancelLink = styled.div`
  font-size: 13px;
  line-height: 20px;
  margin: 24px;
  color: #0376DA;
  cursor: pointer;
  text-align: center;
`

export default () => {
  const logout = () => {
    window.location = appConfig.current.getLogoutUrl()
  }

  return <CancelLink onClick={logout}>{translate('logout')}</CancelLink>
}
